import React from 'react'
import { connect } from 'react-redux'
import { setUpdatingContent } from 'reducers'
import { isEmpty } from 'lodash'

const mapStateToProps = (state, props) => ({
  isUpdatingContent: state.app.isUpdatingContent,
})

@connect(mapStateToProps)
class AppContent extends React.Component {


  shouldComponentUpdate(nextProps: { isUpdatingContent: boolean }) {
    if (this.props.isUpdatingContent && !nextProps.isUpdatingContent) {
      return false
    }
    return true
  }

  componentDidUpdate() {
    const { isUpdatingContent, dispatch } = this.props
    if (isUpdatingContent) {
      dispatch(setUpdatingContent(false))
    }
  }

  render() {
    const { getContentBuffer } = this.context
    const { pathName, content } = getContentBuffer()
    return isEmpty(content) ? (
      <div className="utils__loadingPage" />
    ) : (
      <div className="utils__content">
        {/*<Breadcrumb name={pathName} /> */}
        {content}
      </div>
    )
  }
}

export default AppContent



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Content/index.js